import type { FundraisingResponse } from '@shared/schemas';

/**
 * Redux state for the Fundraisings index: a read-only listing of the team's
 * fundraising rounds. `error` holds a human-readable message when the load
 * fails (surfaced by the page); the old `useApi` version silently swallowed
 * it. Every field is serialisable.
 */
export interface FundraisingsState {
  rows: FundraisingResponse[];
  loading: boolean;
  error: string | null;
  /** True once a first load has settled; a deep link waits for it before looking up a round. */
  loaded: boolean;
}

export const initialState: FundraisingsState = {
  rows: [],
  loading: false,
  error: null,
  loaded: false,
};
